import axios from '@/zenky';
import { getErrorCode } from '@/helpers/apiErrors';
import handleApiInvalidPasswordErrorIfPresent from '../handleApiInvalidPasswordErrorIfPresent';
import handleApiCooldownErrorIfPresent from '../handleApiCooldownErrorIfPresent';
import generateSignUpApiData from './generateSignUpApiData';

export default async function () {
  const reqData = {
    ...generateSignUpApiData.call(this),
  };

  const recaptchaToken = await this.$store.dispatch('recaptcha/getToken', 'registration');

  if (recaptchaToken) {
    reqData.recaptcha = { token: recaptchaToken };
  }


  try {
    const registerResponse = await axios.post('/auth/register', reqData);

    console.log(registerResponse);
    const response = registerResponse.data.data;

    if (response.confirmation_required) {
      this.stage = 'code';
    } else {
      this.page = 'registration_completed_without_verification';
    }
  } catch (err) {
    const errorCode = getErrorCode(err);

    if (errorCode === 'auth.already_registered') {
      const reqDataResend = {
        phone: this.phone,
        phone_country: this.phone_country,
      };

      const recaptchaTokenResend = await this.$store.dispatch('recaptcha/getToken', 'resend_registration_code');

      if (recaptchaTokenResend) {
        reqDataResend.recaptcha = { token: recaptchaTokenResend };
      }

      const reqResend = axios.post('/auth/register/resend', reqDataResend);

      try {
        await reqResend;
      } catch (err) {
        if (handleApiCooldownErrorIfPresent.call(this, err)) {
          return
        }

        throw err;
      }
    } else if (handleApiInvalidPasswordErrorIfPresent.call(this, err) || handleApiCooldownErrorIfPresent.call(this, err)) {
      return;
    } else {
      throw err;
    }
  }
};
